// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3hpZ5","notes":"Notes_notes__3VKXT"};